import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash-es/get';
import { connect } from 'react-redux';
import { Box, Heading } from '@components/common';
import ServiceTypeSelector from './ServiceTypeSelector';

import { AppSelectors } from '@redux/AppRedux';
import ScheduleActions from '@redux/ScheduleRedux';
import { SERVICE_TYPES, TIME_FRAME } from '@services/minte';

function BookingBoardHeader(props) {
  const {
    title,
    serviceTypeData,
    setItemSelected,
    // eslint-disable-next-line no-unused-vars
    property,
    propertyInfo,
    ...restProps
  } = props;

  const serviceTypes = [SERVICE_TYPES.HOTEL_STYLE, SERVICE_TYPES.DEEP_CLEAN];

  return (
    <Box
      px={2}
      height={48}
      flexDirection="row"
      display="flex"
      justifyContent="space-between"
      alignSelf="stretch"
      {...restProps}
    >
      <Heading px={2} py={0} my={0} display={['none', 'block', 'block']}>
        {title}
      </Heading>
      <Box
        flexDirection="row"
        display="flex"
        flex={1}
        justifyContent="flex-end"
        px={[0, 2, 2]}
      >
        {serviceTypes.map((serviceType, index) => (
          <Box
            key={serviceType}
            flex={[1, 'unset', 'unset']}
            ml={index === 0 ? 0 : 2}
          >
            <ServiceTypeSelector
              data={serviceTypeData[serviceType]}
              price={get(propertyInfo, `serviceTypes.${serviceType}`, 0)}
              serviceType={serviceType}
              onDrop={(row, col) => {
                if (row === -1 || col === -1) {
                  return;
                }
                setItemSelected(row, col, serviceType);
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

BookingBoardHeader.propTypes = {
  title: PropTypes.string,
  serviceTypeData: PropTypes.object,
  setItemSelected: PropTypes.func,
  property: PropTypes.object,
  propertyInfo: PropTypes.object
};

const mapStatesToProps = (state, { property }) => ({
  serviceTypeData: AppSelectors.selectServiceTypeData(state),
  propertyInfo: AppSelectors.selectPropertyInfoOf(state, property)
});

const mapDispatchToProps = dispatch => ({
  setItemSelected: (row, col, serviceType) =>
    dispatch(
      ScheduleActions.addSelectedItem({
        row,
        col,
        serviceType,
        timeframe: TIME_FRAME.ANYTIME
      })
    )
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(BookingBoardHeader);
